/**
 * SupportFloatingWidget — F-013.
 *
 * Bottone floating mostrato nella detail view pratica: apre `SupportTicketModal`
 * con `praticaId` auto-popolato (contesto pratica, UC-020 step 4/BR-5).
 */
import { useState } from 'react';
import { LifeBuoy } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { SupportTicketModal } from './SupportTicketModal';

interface SupportFloatingWidgetProps {
  praticaId: string;
}

export function SupportFloatingWidget({ praticaId }: SupportFloatingWidgetProps) {
  const [open, setOpen] = useState(false);

  return (
    <>
      <Button
        type="button"
        onClick={() => setOpen(true)}
        className="fixed bottom-6 right-6 z-40 rounded-full shadow-lg"
        size="lg"
        aria-label="Contatta supporto"
      >
        <LifeBuoy className="h-4 w-4" aria-hidden="true" />
        <span className="ml-2 hidden sm:inline">Supporto</span>
      </Button>
      <SupportTicketModal open={open} onOpenChange={setOpen} praticaId={praticaId} />
    </>
  );
}
